import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { QuoteError } from '~/lib/types/basket-types';

const CmsContent = lazy(() => import('~/components/core/content/cms-content'));

type props = {
  onClose: () => void;
  errorMessages?: QuoteError[];
};

const ChangeService: React.FC<props> = () => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  return (
    <Suspense>
      <CmsContent contentKey="service-switcher-change-service" wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}>
        <P2GText variant="h2" dataTestId="service-switcher-error-title">
          {t('SERVICE_SWITCHER_TITLE', { defaultValue: 'Alternative Services' })}
        </P2GText>
      </CmsContent>
    </Suspense>
  );
};
export default ChangeService;
